import React from 'react';
import PropTypes from 'prop-types';
import Helmet from 'react-helmet';

import RawHTML from './helpers/RawHTML';

import GenerateMetaTags from '../components/GenerateMetaTags';
import Breadcrumbs from '../components/Breadcrumbs';
import Article, { Title, FeaturedImage, Excerpt, Content } from './Article';
import Shortcuts from './Shortcuts';
import Accordion from './Accordion';
import FormChooser from './forms/FormChooser';

const mediaPath = process.env.REACT_APP_MEDIA_PATH;

export default function PostArticle({ post, post: { acf } }) {
	return (
		<Article>
			<Helmet>
				{GenerateMetaTags({
					title: post.title.rendered,
					description: post.excerpt.rendered,
				})}
			</Helmet>

			<Breadcrumbs breadcrumbs={null} />

			<Title>{post.title.rendered}</Title>

			{acf.intro && <Excerpt>{acf.intro}</Excerpt>}

			{post.embedded.featuredmedia &&
				post.embedded.featuredmedia.length !== 0 &&
				acf.show_feature_image && (
					<FeaturedImage
						src={`${mediaPath}/${
							post.embedded.featuredmedia[0].media_details.file
						}`}
					/>
				)}

			{acf.shortcuts &&
				acf.shortcuts !== 0 &&
				acf.shortcuts_placement.value === 'before' && (
					<Shortcuts
						type={acf.shortcuts_type.value}
						shortcuts={acf.shortcuts}
					/>
				)}

			<Content>
				<RawHTML html={post.content.rendered} />
			</Content>

			{acf.shortcuts &&
				acf.shortcuts !== 0 &&
				acf.shortcuts_placement.value === 'after' && (
					<Shortcuts
						type={acf.shortcuts_type.value}
						shortcuts={acf.shortcuts}
					/>
				)}

			{acf.accordion_items &&
				acf.accordion_items !== 0 && (
					<Accordion
						title={acf.accordion_title}
						items={acf.accordion_items}
					/>
				)}

			{acf.form && <FormChooser form={acf.form} />}
		</Article>
	);
}

PostArticle.propTypes = {
	post: PropTypes.object.isRequired,
};
